export const COMPANIES_TABLE = {
    'COMPANIES.COLUMN.CLIENT_NAME': 'Nume client',
    'COMPANIES.COLUMN.NAME': 'Nume companie',
    'COMPANIES.COLUMN.FISCAL_IDENTIFIER': 'NIF/CIF companie',
    'COMPANIES.COLUMN.ROLES': 'Roluri utilizate',
    'COMPANIES.COLUMN.NUMBER_OF_ACTIVE_USERS': 'Utilizatori activi',
    'COMPANIES.COLUMN.NUMBER_OF_CALCULATIONS': 'Număr calculații',
    'COMPANIES.COLUMN.STATUS': 'Status companie',
    'COMPANIES.COLUMN.DATE': 'Dată actualizare',
    'COMPANIES.COLUMN.UPDATED_BY': 'Actualizat de',
    'COMPANIES.COLUMN.ACTIONS': 'Acțiuni',
    'COMPANIES.SEARCH_PLACEHOLDER': 'Caută Nume companie/Nume client',
    'COMPANIES.ACTION.ADD': 'Companie nouă',
    'COMPANIES.ACTION.EDIT': 'Editează',
    'COMPANIES.ACTION.VIEW': 'Vizualizează',
    'COMPANIES.ACTION.HISTORICAL_MODULE': 'Modul istoric',
    'COMPANIES.ACTION.DELETE': 'Șterge compania',
    'COMPANIES.FILTER.STATUS': 'Status'
};
